
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...paths]",
      function () {
        return require("private-next-pages/[...paths].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...paths]"])
      });
    }
  